import styled from "styled-components";
import { ICON_SIZES, Icon } from "../icon/Icon";
import {
  AlertDescription,
  AlertTitle,
  Box,
  Alert as ChakraAlert,
  CloseButton,
} from "@chakra-ui/react";
import { RADIUS_SIZES } from "../../config/radius-sizes";
import { SHADOWS } from "src/apps/config/shadows";
import { T } from "../i18n/Translation";
import { colors } from "@permisso/permisso-components";

interface AlertProps {
  backgroundColor: string;
  color: string;
  icon: JSX.Element;
  title: string;
  message: string;
  messageParams: Record<string, string>;
  onClose: () => void;
}

// TODO: move to permisso components library
export const Alert = ({
  backgroundColor,
  title,
  color,
  message,
  messageParams,
  icon,
  onClose,
}: AlertProps) => {
  const ALERT_WIDTH = 370;
  return (
    <AlertContainer backgroundColor={backgroundColor} width={ALERT_WIDTH}>
      <StyledIcon path={icon} color={color} size={ICON_SIZES.s24} />
      <StyledBox>
        <AlertTitle color={color}>
          <T k={title} />
        </AlertTitle>
        <AlertDescription color={color}>
          <T k={message} params={messageParams} />
        </AlertDescription>
      </StyledBox>
      <StyledCloseButton
        alignSelf="center"
        onClick={onClose}
        height={`${ICON_SIZES.s24}rem`}
        width={`${ICON_SIZES.s24}rem`}
      />
    </AlertContainer>
  );
};

const AlertContainer = styled(ChakraAlert)`
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  align-items: center;
  border-radius: ${RADIUS_SIZES.base};
  box-shadow: ${SHADOWS.base};
  word-break: break-word;
`;

const StyledIcon = styled(Icon)``;
const StyledCloseButton = styled(CloseButton)`
  color: ${colors.grey700};
`;
const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
